import {LOW_RATING_ADVANTAGE_RATING_THRESHOLD} from "../../configs/lowRatingAdvantage";

/**
 * Положена ли игроку с таким рейтингом фора новичкам (см.
 * configs/lowRatingAdvantage). Решается один раз на старте партии — сервером
 * для сетевой, клиентом для локальной — и кладется игроку признаком
 * hasLowRatingAdvantage; дальше рейтинг уже не читается.
 *
 * Неизвестный рейтинг (null, undefined, не число — например, не удалось
 * прочитать аккаунт) форы не дает: ошибочно ослабить ботов против сильного
 * игрока хуже, чем один раз не выдать фору. У гостя и у нового аккаунта
 * рейтинг 0 — им фора положена.
 *
 * @param {number|null} [rating]
 * @returns {boolean}
 */
export const checkIfLowRatingAdvantage = (rating) => (
  typeof rating === 'number'
  && Number.isFinite(rating)
  && rating < LOW_RATING_ADVANTAGE_RATING_THRESHOLD
);

/**
 * Положена ли фора игроку ЛОКАЛЬНОЙ партии — по профилю того, кто сидит за
 * устройством (сетевым партиям признак ставит сервер по рейтингу аккаунта).
 *
 * Гостю фора положена всегда: аккаунта и настоящего рейтинга у него нет, а
 * рейтинг в гостевом профиле — витринная заглушка под золотую иконку меню
 * (GUEST_RATING), по ней новичок без аккаунта остался бы без форы.
 *
 * @param {{isGuest?: boolean, rating?: number|null}} [auth] - профиль из
 *   state.private.auth
 * @returns {boolean}
 */
export const checkIfAccountHasLowRatingAdvantage = (auth) => (
  Boolean(auth?.isGuest) || checkIfLowRatingAdvantage(auth?.rating)
);
